export default __webpack_public_path__ + "static/img-origin-capital-37309a1bba2daf64fee2b99ebe97c1df.png";